module.exports = __webpack_public_path__ + "img/amex.6f5b0100.svg";